import { memo, useCallback } from "react";
import { Stack, TextField, Typography } from "@mui/material";
import { StepTypeEditorProps } from "../types";

export const EntityRepresentativesStepTypeSpecificProps = memo(
  ({ step, onChange }: StepTypeEditorProps) => {
    const apps = step.apps ?? {
      representative: "",
      ubo: "",
    };

    const setApp = useCallback(
      (targetKey: "representative" | "ubo", nextValue: string) => {
        onChange({
          ...step,
          apps: {
            representative:
              targetKey === "representative" ? nextValue : apps.representative,
            ubo: targetKey === "ubo" ? nextValue : apps.ubo,
          },
        });
      },
      [apps.representative, apps.ubo, onChange, step],
    );

    return (
      <Stack spacing={0} sx={{ pt: 0.5, maxWidth: 500 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          KYC Processes
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          component="div"
          sx={{ mb: 1.5, mt: 0 }}
        >
          Representative app is used when a person is both Representative and UBO.
        </Typography>
        <Stack spacing={1}>
          <TextField
            size="small"
            label="Representative KYC app"
            value={apps.representative}
            onChange={(e) => setApp("representative", e.target.value)}
            fullWidth
          />
          <TextField
            size="small"
            label="UBO-only KYC app"
            value={apps.ubo}
            onChange={(e) => setApp("ubo", e.target.value)}
            fullWidth
          />
        </Stack>
      </Stack>
    );
  },
);
